import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./styled.css";

const questions = [
  {
    option: "a) Apenas aceleradora",
    correct: false,
  },
  {
    option: "b) Apenas otimizadora",
    correct: false,
  },
  {
    option: "c) Para algumas indústrias, apenas acelera",
    correct: false,
  },
  {
    option: "d) Quando consegue acelerar, não otimiza",
    correct: false,
  },
  {
    option: "e) Alice é uma aceleradora e otimizadora",
    correct: true,
  },
];

export default function Question25(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question25: {
          title:
            "Alice é uma aceleradora e otimizadora de projetos de Data Science?",
          option: option.option,
          correct: option.correct,
          order: 25
        },
      };
    });
  }
  return (
    <div style={{ marginTop: 30 }}>
      <h5 style={{ textAlign: "center" }}>
        {t(
          "Alice é uma aceleradora e otimizadora de projetos de Data Science?"
        )}
      </h5>

      <div className="div-options-question-ste">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-ste ${
              optionSelected === e.option && "selected-option-question-ste"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
